export const BENCHMARK_TYPES = [
  {
    id: "industry_average",
    label: "Industry Average",
    shortLabel: "Industry Avg",
    description:
      "Typical performance for organizations in your sector, based on peer intensity bounds and sector benchmarks.",
    color: "#64748b",
  },
  {
    id: "industry_leaders",
    label: "Industry Leaders",
    shortLabel: "Leaders",
    description:
      "Top-quartile performers in your industry — organizations setting the pace on material KPIs.",
    color: "#0d9488",
  },
  {
    id: "country_average",
    label: "Country Average",
    shortLabel: "Country",
    description:
      "National sustainability performance adjusted for your organization's operating country.",
    color: "#3b82f6",
  },
  {
    id: "regional_average",
    label: "Regional Average",
    shortLabel: "Region",
    description:
      "Regional peer average across your geographic market (e.g. Middle East, Europe, Asia Pacific).",
    color: "#8b5cf6",
  },
  {
    id: "company_size",
    label: "Company Size",
    shortLabel: "Size Peers",
    description:
      "Organizations with a similar employee count band to yours.",
    color: "#f59e0b",
  },
  {
    id: "organization_type",
    label: "Organization Type",
    shortLabel: "Org Type",
    description:
      "Peers matched by industry / organization classification.",
    color: "#ec4899",
  },
  {
    id: "previous_assessment",
    label: "Previous Assessment",
    shortLabel: "Prior Year",
    description:
      "Your most recent prior SI assessment for year-over-year progress tracking.",
    color: "#6366f1",
  },
  {
    id: "global_best_practices",
    label: "Global Best Practices",
    shortLabel: "Global Best",
    description:
      "Leading global benchmarks aligned with schema lower bounds and best-in-class targets.",
    color: "#059669",
  },
  {
    id: "custom",
    label: "Custom Benchmark Groups",
    shortLabel: "Custom",
    description:
      "User-defined target scores saved for your organization or stakeholder groups.",
    color: "#14b8a6",
  },
  {
    id: "request_peer_companies",
    label: "Request Peer Companies",
    shortLabel: "Request Peers",
    description:
      "Request a custom benchmark against companies you select. Processed manually by the GE3S team.",
    color: "#0f766e",
  },
];

export const SECTION_META = [
  { key: "base", label: "Base / Sector", color: "#02b880" },
  { key: "environment", label: "Environmental", color: "#3b82f6" },
  { key: "social", label: "Social", color: "#f59e0b" },
  { key: "governance", label: "Governance & Economics", color: "#8b5cf6" },
];

export const CUSTOM_BENCHMARK_STORAGE_KEY = "si_custom_benchmark_groups";
